import React, { PureComponent } from 'react';
import { Row, Col } from 'react-grid-system';

import { Button } from 'components/button';
import { Grid } from 'components/grid';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

class AccessSelectDatePickers extends PureComponent {
  static propTypes = {
    uncheckAllOptions: PropTypes.func,
    cleanData: PropTypes.func,
    setValue: PropTypes.func,
    field: PropTypes.string
  };

  render() {
    const { uncheckAllOptions, cleanData, setValue, field } = this.props;

    return (
      <Grid className="access__select__grid__container access__select__grid__clean">
        <Row nogutter>
          <Col className="access__select__date__cancel" xs={6}>
            <Button
              type="cancel"
              size="small"
              onClick={() => {
                uncheckAllOptions();
                cleanData(field);
              }}
            >
              <I18n label="general.clean" />
            </Button>
          </Col>
          <Col xs={6}>
            <Button
              size="medium"
              outline
              className="access__select__clean__button"
              onClick={setValue}
            >
              <I18n label="general.ok" />
            </Button>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default AccessSelectDatePickers;
